<template>
  <div class="coupon">
     <van-nav-bar title="优惠券" left-text="返回" left-arrow @click-left="$router.back()"></van-nav-bar> 

    <van-cell class="mt-10">
      <div class="bg-fff flex jc-sb aic rel">
        <p class="l flex2 red aic jc-c">
          <span class="f24">30<span class="f10">元</span></span>
          <span class="mt-5"> (满100可用)</span>
        </p>
        <p class="r flex2 aic">
          <span class="f14">满减券</span>
          <span class="f999 f12">2019.12.18至2020.12.18</span>
        </p>
        <p>
           <span class="get fcc f12">立即领取</span>
        </p>
      </div>
    </van-cell>
    <van-cell>
      <div class="bg-fff flex jc-sb aic rel">
        <p class="l flex2 red aic jc-c">
          <span class="f24">50<span class="f10">元</span></span>
          <span class="mt-5"> (满100可用)</span>
        </p>
        <p class="r flex2 aic">
          <span class="f14">满减券</span>
          <span class="f999 f12">2019.12.18至2020.12.18</span>
        </p>
        <p>
           <span class="get fcc f12">立即领取</span>
        </p>
      </div>
    </van-cell>
    <van-cell>
      <div class="bg-fff flex jc-sb aic rel">
        <p class="l flex2 red aic jc-c">
          <span class="f24">100<span class="f10">元</span></span>
          <span class="mt-5"> (满100可用)</span>
        </p>
        <p class="r flex2 aic">
          <span class="f14">满减券</span>
          <span class="f999 f12">2019.12.18至2020.12.18</span>
        </p>
        <p>
           <span class="get fcc f12">立即领取</span>
        </p>
      </div>
    </van-cell>

  </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
.coupon {
  .get {
    // background: #ff4d64;
    border: 1px solid @red;
    color: @red;
    // color: #fff;
    width: 60px;
    border-radius: 30px;
    // padding: 3px 10px;
  }
}
</style>